import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { SuketBaseWithRelationship } from "@/types/suket_tato-tindik";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import CommonFormulir, { EnFormulirCategory } from "@/services/CommonFormulir";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "formulir-uji-fungsi-kfr"
})
class FormulirUjiFungsiKfr extends VuexModule {
  formulir: SuketBaseWithRelationship = null;
  loading = false;

  http: CommonFormulir = new CommonFormulir(EnFormulirCategory.UjiFungsiKfr);

  get register(): any {
    return RegisterKunjungan.register;
  }

  @Mutation
  SET_DATA(formulir: SuketBaseWithRelationship) {
    this.formulir = formulir;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async fetchFormByRegister(): Promise<void> {
    this.SET_LOADING(true);

    const formArray = await this.http
      .getByRegister(this.register.no)
      .finally(() => {
        this.SET_LOADING(false);
      });

    // const response = formArray.data.length ? formArray[0] : null;
    this.SET_DATA(formArray.data.length ? formArray.data[0] : null);
  }

  @Action({ rawError: true })
  async getByRegister(noReg): Promise<void> {
    this.SET_LOADING(true);

    const formArray = await this.http.getByRegister(noReg).finally(() => {
      this.context.commit("SET_LOADING", false);
    });

    this.SET_DATA(formArray.data.length ? formArray.data[0] : null);
  }
}

export default getModule(FormulirUjiFungsiKfr);
